export { default } from './get-can-challenge-biometrics';
